

<script>
import { Pie } from "vue-chartjs"

export default {
  extends: Pie,
  props: {
    pieProps: Object
  },
  data() {
    return {
      options: {
        legend: {
          display: true,
          position: 'right'
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const total = data.datasets[0].data.reduce((acc, val) => acc + val, 0);
              const value = data.datasets[0].data[tooltipItem.index];
              const percentage = ((value / total) * 100).toFixed(1);
              return data.labels[tooltipItem.index] + ': $' + value.toLocaleString() + ' (' + percentage + '%)';
            }
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(
      {
        labels: this.pieProps.label,
        datasets: [{
          label: 'My First Dataset',
          data: this.pieProps.data,
          backgroundColor: this.pieProps.colors,
          hoverOffset: 4
        }]
      },
      this.options
    );
  },
};
</script>